export const baseURL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL
  : 'http://localhost:3001';

export const AWSPlaceIndexURL =
  'https://places.geo.us-east-1.amazonaws.com/places/v0/indexes/';
